<div class="border-top">
  <div class="guts-m-full-1">
    <div *ngIf="!isLoading; else skeleton">
      <div class="l_flexbar l_flex-middle">
        <h4
          class="h3 ib header-shrink"
          data-dgat="learner-home-focus-skills-ttl"
        >
          {{ i18n.dgProfileOverview_FocusSkills }}
        </h4>
        <ng-container *dgxFeatureToggle="'focus-skill-quick-add'">
          <div
            class="
              badge badge-pill badge-pill--compact
              badge-neutral
              guts-m-l-auto
              __remaining-focus-skills
            "
          >
            {{ focusSkills.length }}/{{ maxFocusSkills }}
          </div>
          <div
            [ngbTooltip]="tooltip"
            [disableTooltip]="focusSkills.length < maxFocusSkills"
          >
            <button
              #popoverTrigger
              (click)="togglePopover()"
              [attr.aria-label]="i18n.DashboardNav_AddFocusSkills"
              data-dgat="learner-home-focus-skills-8e3"
              class="__add-focus-skill"
              [class.is_disabled]="focusSkills.length >= maxFocusSkills"
              [disabled]="focusSkills.length >= maxFocusSkills"
            >
              <df-icon
                icon="plus"
                class="color-ebony-a45"
                size="small"
              ></df-icon>
            </button>
          </div>

          <ng-template #tooltip>
            <div [innerHtml]="i18n.DashboardNav_MaxFocusSkillDesc"></div>
          </ng-template>

          <dgx-quick-add-focus-skill-popover
            #quickAddRef
            [popoverTrigger]="popoverTriggerRef"
            [(isOpen)]="addFocusSkillPopoverOpen"
            (skillSelected)="skillSelected($event)"
          ></dgx-quick-add-focus-skill-popover>
        </ng-container>
      </div>
      <div class="l_flex l_flex-wrap guts-m-v-1-half">
        <dgx-tag-pill
          *ngFor="let skill of focusSkills"
          [showCompleteOnly]="true"
          [tag]="skill"
          (tagClick)="openSkillRatingModal($event, skill)"
          (ratingsViewed)="onSkillRatingPopoverViewed(skill)"
          data-dgat="learner-home-focus-skills-f5b"
          dgatInput="learner-home-focus-skills-f49"
          pillClasses="learner-home-focus-skill"
          triggers="hover"
        ></dgx-tag-pill>
        <!-- Focus Skill Empty State Paragraph  -->
        <div
          class="guts-m-b-quart empty-state"
          *ngIf="focusSkills.length === 0"
        >
          {{ i18n.dgProfileOverview_FocusSkills_EmptyState }}
        </div>
      </div>
      <!-- Manage skills -->
      <div *ngIf="focusSkills.length" class="l_flexbar guts-m-t-quart">
        <a
          [attr.href]="focusSkillsUrl"
          class="link par--small font-semibold"
          (click)="trackClick('Manage Skills')"
          data-dgat="learner-home-focus-skills-cee"
        >
          <div class="l_flexbar">
            <div class="guts-m-r-1">
              {{ i18n.dgOrgSecurity_ManageSkills }}
            </div>
            <df-icon
              class="guts-m-l-quart"
              icon="chevron-right"
              size="small"
            ></df-icon>
          </div>
        </a>
      </div>
    </div>
    <ng-template #skeleton>
      <div class="skeleton-container">
        <div
          class="skeleton__line bg-animate grid__col-5 guts-m-b-2 guts-p-full-0"
        ></div>
        <div class="grid">
          <div
            class="
              skeleton__line skeleton__line--medium
              bg-animate
              grid__col-5
              guts-m-b-1 guts-p-full-0 guts-m-r-half
            "
          ></div>
          <div
            class="
              skeleton__line skeleton__line--medium
              bg-animate
              grid__col-5
              guts-m-b-1 guts-p-full-0
            "
          ></div>
        </div>
        <div class="grid">
          <div
            class="
              skeleton__line skeleton__line--medium
              bg-animate
              grid__col-4
              guts-m-b-1 guts-p-full-0 guts-m-r-half
            "
          ></div>
          <div
            class="
              skeleton__line skeleton__line--medium
              bg-animate
              grid__col-1
              guts-m-b-1 guts-p-full-0
            "
          ></div>
        </div>
        <div
          class="skeleton__line bg-animate grid__col-3 guts-m-t-1 guts-p-full-0"
        ></div>
      </div>
    </ng-template>
  </div>
</div>
